// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_homeScreen__cEY01 {
  display: flex;
  min-height: 100vh;
  background: #f8f9fa; }

.styles_sidebar__vPOd4 {
  position: fixed;
  left: 2rem;
  top: 2rem;
  width: 280px;
  height: calc(100vh - 4rem);
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow: hidden; }

.styles_sidebarHeader__uH0Zr {
  padding: 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa; }

.styles_searchInput__SVsmH {
  margin-top: 1rem; }

.styles_sidebarContent__BvKKM {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem 0; }

.styles_loadingState__PjAar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem; }

.styles_errorState__ukR1z {
  padding: 1rem;
  color: #dc3545; }

.styles_componentsList__YsI36 {
  padding: 0 1rem; }

.styles_section__dpyzX {
  margin-bottom: 2rem; }
  .styles_section__dpyzX:last-child {
    margin-bottom: 0; }

.styles_sectionTitle__g9gZT {
  color: #6c757d;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px; }

.styles_sectionComponents__uoOP0 {
  display: flex;
  flex-direction: column;
  gap: 0.25rem; }

.styles_componentItem__wxBR8 {
  padding: 0.75rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease; }
  .styles_componentItem__wxBR8:hover {
    background: #f8f9fa;
    color: #007bff; }

.styles_componentName__H6Z4z {
  font-weight: 500;
  color: #495057;
  margin: 0; }

.styles_sidebarFooter__u6gQN {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa; }

.styles_componentCount__WZPSo {
  color: #6c757d;
  text-align: center; }

.styles_mainContent__9KgSI {
  flex: 1 1;
  margin-left: 320px;
  padding: 2rem; }

.styles_contentContainer__yf3yq {
  max-width: 800px; }

.styles_welcomeSection__fdV-A {
  margin-bottom: 3rem; }

.styles_statsGrid__xfpjW {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem; }

.styles_statCard__WXeQ4 {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  text-align: center;
  transition: all 0.2s ease; }
  .styles_statCard__WXeQ4:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px); }

.styles_quickStartSection__0Gcb\\+ {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid #e9ecef; }

.styles_codeBlock__SRui6 {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1.5rem;
  overflow-x: auto; }
  .styles_codeBlock__SRui6 pre {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 0.9rem;
    color: #495057;
    margin: 0;
    line-height: 1.5; }

@media (max-width: 1200px) {
  .styles_sidebar__vPOd4 {
    width: 250px; }
  .styles_mainContent__9KgSI {
    margin-left: 290px; } }

@media (max-width: 768px) {
  .styles_homeScreen__cEY01 {
    flex-direction: column; }
  .styles_sidebar__vPOd4 {
    position: relative;
    left: auto;
    top: auto;
    width: 100%;
    height: auto;
    max-height: 60vh;
    margin-bottom: 2rem; }
  .styles_mainContent__9KgSI {
    margin-left: 0;
    padding: 1rem; }
  .styles_statsGrid__xfpjW {
    grid-template-columns: 1fr; } }

.styles_sidebarContent__BvKKM::-webkit-scrollbar {
  width: 6px; }

.styles_sidebarContent__BvKKM::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px; }

.styles_sidebarContent__BvKKM::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px; }
  .styles_sidebarContent__BvKKM::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/screens/home/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB,EAAA;;AAGlB;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,cAAc,EAAA;;AAGhB;EACE,eAAe,EAAA;;AAGjB;EACE,mBAAmB,EAAA;EADrB;IAII,gBAAgB,EAAA;;AAIpB;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB,EAAA;;AAGvB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,yBAAyB,EAAA;EAJ3B;IAOI,mBAAmB;IACnB,cAAc,EAAA;;AAIlB;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS,EAAA;;AAGX;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa,EAAA;;AAGf;EACE,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB,EAAA;EAN3B;IASI,wCAAwC;IACxC,2BAA2B,EAAA;;AAI/B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EAAA;EALlB;IAQI,wDAAwD;IACxD,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,gBAAgB,EAAA;;AAKpB;EACE;IACE,YAAY,EAAA;EAGd;IACE,kBAAkB,EAAA,EACnB;;AAGH;EACE;IACE,sBAAsB,EAAA;EAGxB;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB,EAAA;EAGrB;IACE,cAAc;IACd,aAAa,EAAA;EAGf;IACE,0BAA0B,EAAA,EAC3B;;AAIH;EACE,UAAU,EAAA;;AAGZ;EACE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB;EACnB,kBAAkB,EAAA;EAFpB;IAKI,mBAAmB,EAAA","sourcesContent":[".homeScreen {\n  display: flex;\n  min-height: 100vh;\n  background: #f8f9fa;\n}\n\n.sidebar {\n  position: fixed;\n  left: 2rem;\n  top: 2rem;\n  width: 280px;\n  height: calc(100vh - 4rem);\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.sidebarHeader {\n  padding: 1.5rem;\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.searchInput {\n  margin-top: 1rem;\n}\n\n.sidebarContent {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 0;\n}\n\n.loadingState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  gap: 1rem;\n}\n\n.errorState {\n  padding: 1rem;\n  color: #dc3545;\n}\n\n.componentsList {\n  padding: 0 1rem;\n}\n\n.section {\n  margin-bottom: 2rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.sectionTitle {\n  color: #6c757d;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.sectionComponents {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.componentItem {\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f8f9fa;\n    color: #007bff;\n  }\n}\n\n.componentName {\n  font-weight: 500;\n  color: #495057;\n  margin: 0;\n}\n\n.sidebarFooter {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.componentCount {\n  color: #6c757d;\n  text-align: center;\n}\n\n.mainContent {\n  flex: 1;\n  margin-left: 320px; // 280px sidebar + 40px gap\n  padding: 2rem;\n}\n\n.contentContainer {\n  max-width: 800px;\n}\n\n.welcomeSection {\n  margin-bottom: 3rem;\n}\n\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.statCard {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  text-align: center;\n  transition: all 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n  }\n}\n\n.quickStartSection {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n}\n\n.codeBlock {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 1.5rem;\n  overflow-x: auto;\n\n  pre {\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n    font-size: 0.9rem;\n    color: #495057;\n    margin: 0;\n    line-height: 1.5;\n  }\n}\n\n// Responsive design\n@media (max-width: 1200px) {\n  .sidebar {\n    width: 250px;\n  }\n\n  .mainContent {\n    margin-left: 290px; // 250px sidebar + 40px gap\n  }\n}\n\n@media (max-width: 768px) {\n  .homeScreen {\n    flex-direction: column;\n  }\n\n  .sidebar {\n    position: relative;\n    left: auto;\n    top: auto;\n    width: 100%;\n    height: auto;\n    max-height: 60vh;\n    margin-bottom: 2rem;\n  }\n\n  .mainContent {\n    margin-left: 0;\n    padding: 1rem;\n  }\n\n  .statsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n// Custom scrollbar for sidebar\n.sidebarContent::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebarContent::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.sidebarContent::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n\n  &:hover {\n    background: #a8a8a8;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeScreen": `styles_homeScreen__cEY01`,
	"sidebar": `styles_sidebar__vPOd4`,
	"sidebarHeader": `styles_sidebarHeader__uH0Zr`,
	"searchInput": `styles_searchInput__SVsmH`,
	"sidebarContent": `styles_sidebarContent__BvKKM`,
	"loadingState": `styles_loadingState__PjAar`,
	"errorState": `styles_errorState__ukR1z`,
	"componentsList": `styles_componentsList__YsI36`,
	"section": `styles_section__dpyzX`,
	"sectionTitle": `styles_sectionTitle__g9gZT`,
	"sectionComponents": `styles_sectionComponents__uoOP0`,
	"componentItem": `styles_componentItem__wxBR8`,
	"componentName": `styles_componentName__H6Z4z`,
	"sidebarFooter": `styles_sidebarFooter__u6gQN`,
	"componentCount": `styles_componentCount__WZPSo`,
	"mainContent": `styles_mainContent__9KgSI`,
	"contentContainer": `styles_contentContainer__yf3yq`,
	"welcomeSection": `styles_welcomeSection__fdV-A`,
	"statsGrid": `styles_statsGrid__xfpjW`,
	"statCard": `styles_statCard__WXeQ4`,
	"quickStartSection": `styles_quickStartSection__0Gcb+`,
	"codeBlock": `styles_codeBlock__SRui6`
};
export default ___CSS_LOADER_EXPORT___;
